import { formatDuration } from "@bandwith/time";
import { EmptyState, MediaItemContent } from "@bandwith/ui";
import { useQuery } from "@tanstack/react-query";
import { ClipboardList, Plus } from "lucide-react";
import { AuthLinkButton } from "../components/AuthLinkButton";
import { RouterLinkWrapper } from "../components/RouterLinkWrapper";
import { setlistsQuery } from "../lib/queries";

export function Setlists() {
  const { data: setlists, isLoading, error } = useQuery(setlistsQuery());

  if (isLoading) {
    return <div className="text-text-muted">Loading setlists...</div>;
  }

  if (error) {
    return <div className="text-red-500">Error: {error.message}</div>;
  }

  return (
    <section>
      <div className="mb-4 flex justify-end">
        <AuthLinkButton to="/setlists/new">
          <Plus aria-hidden="true" className="h-3.5 w-3.5" />
          Add Setlist
        </AuthLinkButton>
      </div>

      {!setlists || setlists.length === 0 ? (
        <EmptyState
          icon={ClipboardList}
          title="No setlists yet"
          description="Create a setlist to organize songs for your next rehearsal or gig"
        />
      ) : (
        <ul className="space-y-2">
          {setlists.map((setlist, index) => {
            const songCount = setlist.songs.length;
            const subtitle =
              [
                `${songCount} ${songCount === 1 ? "song" : "songs"}`,
                setlist.totalDurationSeconds > 0
                  ? formatDuration(setlist.totalDurationSeconds)
                  : null,
              ]
                .filter(Boolean)
                .join(" · ") || undefined;

            return (
              <li
                key={setlist.id}
                className="flex animate-list-item rounded-md border border-border-subtle bg-bg-secondary p-4 transition-colors hover:bg-bg-tertiary"
                style={{ animationDelay: `${index * 30}ms` }}
              >
                <MediaItemContent
                  title={setlist.name}
                  subtitle={subtitle}
                  linkHref={`/setlists/${setlist.id}`}
                  LinkWrapper={RouterLinkWrapper}
                />
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
